import { AuthService } from '@/services';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export const useConfirmForgotPasswordMutation = (
  options: UseMutationOptions<
    {
      email: string;
      verificationCode: string;
      password: string;
    },
    Error,
    unknown,
    unknown
  >,
) => {
  return useMutation({
    mutationFn: AuthService.confirmForgotPassword,
    ...options,
  });
};
